const errorCodes = [
  {
    key: "ALREADY_BOUND",
    value: {
      message: "Only licenes without set hardware identifier can be bound",
      variant: "error",
    },
  },
  {
    key: "ALREADY_UNBOUND",
    value: { message: "License is already unbound", variant: "info" },
  },
  {
    key: "TRIAL_LICENSE_CAN_NOT_BE_UNBOUND_ONCE_ASSIGNED",
    value: {
      message: "Trial license can not be unbound once assigned",
      variant: "warning",
    },
  },
  {
    key: "OTHER_LICENSE_ALREADY_BOUND_WITH_IDENTIFIER",
    value: {
      message: "Other license is already assigned to this identifier",
      variant: "error",
    },
  },
  {
    key: "OTHER_CUSTOMER_ALREADY_BOUND_TO_IDENTIFIER",
    value: {
      message: "Other customer is already assigned to this identifier",
      variant: "error",
    },
  },
  {
    key: "ACCESS_DENIED",
    value: {
      message: "You don't have access to this resource",
      variant: "error",
    },
  },
  {
    key: "NOT_AUTHORIZED",
    value: {
      message: "You are not authorized to send this request",
      variant: "error",
    },
  },
  {
    key: "DEFAULT",
    value: {
      message: "Unrecognized error: ",
      variant: "error",
    },
  },
];
const getErrorMessage = (errorCode) => {
  let errorMessage = errorCodes.find((item) => item.key === errorCode);
  if (!errorMessage) {
    const defaultErrorMessage = errorCodes.find(
      (item) => item.key === "DEFAULT"
    );
    errorMessage = {
      ...defaultErrorMessage,
      value: {
        ...defaultErrorMessage.value,
        message: defaultErrorMessage.value.message + errorCode,
      },
    };
    //errorMessage.value.message = errorMessage.value.message + errorCode
  }
  return errorMessage.value;
};

export default getErrorMessage;
